import { useSearchParams } from "react-router-dom";

function useQuery() {
  const [searchParams, setSearchParams] = useSearchParams();

  return [searchParams, setSearchParams];
}

export default useQuery;
